/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type JoinCondition = {
    kind?: JoinCondition.kind;
};

export namespace JoinCondition {

    export enum kind {
        EQUALITY = 'Equality',
    }


}
